// Fabric Config Service - Fetches MSAL configuration from API

// const FABRIC_CONFIG_API = "https://ds-beverage-api-f5bye7d3a0fdg3eh.centralus-01.azurewebsites.net/api/fabric/config";
// const API_KEY = "2141cb88-2e77-4f41-823b-1015a2ab641e";

const FABRIC_CONFIG_API = process.env.REACT_APP_DOORSHARP_FABRIC_CONFIG_API;
const API_KEY = process.env.REACT_APP_BACKEND_API_KEY;

// Cache for the fetched config
let cachedConfig = null;

/**
 * Fetch MSAL configuration from the fabric config API
 * @returns {Promise<Object>} Configuration object with tenantId, clientId, graphQLEndpoint, etc.
 */
export const fetchFabricConfig = async () => {
  // Return cached config if available
  if (cachedConfig) {
    return cachedConfig;
  }

  try {
    const response = await fetch(FABRIC_CONFIG_API, {
      method: "GET",
      headers: {
        "X-API-Key": API_KEY,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch fabric config: ${response.status}`);
    }

    const config = await response.json();
    
    // Validate required fields
    if (!config.tenantId || !config.clientId) {
      throw new Error("Invalid config: missing tenantId or clientId");
    }

    // Cache the config
    cachedConfig = config;
    
    // Also store in localStorage for persistence
    localStorage.setItem("fabricConfig", JSON.stringify(config));
    
    console.log("Fabric config loaded successfully");
    return config;
  } catch (error) {
    console.error("Error fetching fabric config:", error);
    
    // Try to get from localStorage as fallback
    const storedConfig = localStorage.getItem("fabricConfig");
    if (storedConfig) {
      console.log("Using cached fabric config from localStorage");
      cachedConfig = JSON.parse(storedConfig);
      return cachedConfig;
    }
    
    throw error;
  }
};

/**
 * Get the cached config (synchronous)
 * @returns {Object|null} Cached configuration or null
 */
export const getCachedConfig = () => {
  if (cachedConfig) {
    return cachedConfig;
  }
  
  // Try localStorage
  const storedConfig = localStorage.getItem("fabricConfig");
  if (storedConfig) {
    cachedConfig = JSON.parse(storedConfig);
    return cachedConfig;
  }
  
  return null;
};

/**
 * Clear the cached config
 */
export const clearConfigCache = () => {
  cachedConfig = null;
  localStorage.removeItem("fabricConfig");
};

export default {
  fetchFabricConfig,
  getCachedConfig,
  clearConfigCache,
};

